import uuidv4 from "uuid/v4";
import { promiseImage } from "../misc/utils";
import { labelDimensions, framedDimensions } from "../misc/constants";
import generateText from "./generate-text";

export const generate = async ({
  refWidth,
  refHeight,
  label,
}) => {
  const canvas = document.getElementById("canvas1");
  const ctx = canvas.getContext("2d");

  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = labelDimensions.fillStyle;
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  ctx.drawImage(
    await promiseImage(label.background),
    0,
    0,
    labelDimensions.width,
    labelDimensions.height
  );

  const markers = { ...label.text };

  const sortedMarkers = Object.keys(markers)
    .map(key => markers[key])
    .filter(marker => !marker.skip)
    .sort((a, b) => a.zIndex - b.zIndex);

  for (const marker of sortedMarkers) {
    generateText(marker, canvas, refWidth);
  }

  return {
    src: canvas.toDataURL(),
    labelId: uuidv4()
  };
};

export const generateFramed = async (src, res) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  canvas.width = framedDimensions.width;
  canvas.height = framedDimensions.height;

  if (framedDimensions.fillStyle) {
    ctx.fillStyle = framedDimensions.fillStyle;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }

  ctx.drawImage(
    await promiseImage(src),
    framedDimensions.paddingLeft,
    framedDimensions.paddingTop,
    labelDimensions.width,
    labelDimensions.height
  );

  return canvas.toDataURL();
};



// WEBPACK FOOTER //
// ./src/actions/generate.js